import React, { useEffect, useState } from "react";

import { Info } from "icons";

import {
  Table,
  PageLoader,
  Tooltip,
  Pagination,
  Typography,
} from "clearsense-ui/components";

const PreviewTable = ({ previewTables, currentTab, selectedColumns }) => {
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    setPageNumber(1);
  }, [currentTab]);

  return (
    <>
      {previewTables[currentTab] === "loading" ? (
        <PageLoader />
      ) : (
        <div
          style={{
            height: previewTables[currentTab].length <= 100 ? "90%" : "109.5%",
          }}
        >
          <Table
            fixedHeight
            totalCount={previewTables[currentTab].length}
            currentPageNumber={pageNumber}
            paginationProps={{ className: "hidden" }}
            allowRowClick={false}
            data-cy="sql-editor-preview-table"
            columnData={
              previewTables?.[currentTab]?.[0]
                ? Object.keys(previewTables?.[currentTab]?.[0])
                    ?.filter(columnName => !columnName.includes("airbyte"))
                    ?.map(columnName => ({
                      key: columnName,
                      dataIndex: columnName,
                      title: columnName,
                      width: Math.max(12 * columnName.length, 200),
                      ellipsis: true,
                      render: cellValue => cellValue || "N/A",
                    }))
                : selectedColumns?.[currentTab]
                    ?.filter(columnName => !columnName[0].includes("airbyte"))
                    ?.map(columnName => ({
                      key: columnName[0],
                      dataIndex: columnName[0],
                      title: columnName[0],
                      width: Math.max(12 * columnName.length, 200),
                      ellipsis: true,
                      render: cellValue => cellValue || "N/A",
                    }))
            }
            rowData={previewTables[currentTab]}
            className="text-xs"
            rowSelection={false}
          />
          <div className="flex items-center cs-ui-table-background">
            <Tooltip
              content="Preview limited to a maximum of 1000 rows. To view more rows, please use the SQL editor."
              position="top-start"
            >
              <Typography className="ml-4">
                <Info size={16} />
              </Typography>
            </Tooltip>
            <Pagination
              currentPage={pageNumber}
              pageSize={100}
              totalRecordsCount={previewTables[currentTab].length}
              setCurrentPage={setPageNumber}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default PreviewTable;
